import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
//
import Locations from "../views/Locations.vue";
import InspectionArea from "../views/InspectionArea.vue";
import InspectionZone from "../views/InspectionZone.vue";
import ReportForm from "../views/reports/ReportForm.vue";
import Report from "../views/reports/ReportDashboard.vue";
import Home from "../views/Home.vue";
import Client from "../views/clients/ClientPage.vue";
import Project from "../views/projects/ProjectPage.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "SurveyRoute",
    component: Report,
    props: true
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    props: true
  },
  {
    path: "/clients",
    name: "Client",
    component: Client,
    props: true
  },
  {
    path: "/projects",
    name: "Project",
    component: Project,
    props: true
  },
  {
    path: "/inspection_areas",
    name: "InspectionArea",
    component: InspectionArea,
    props: true
  },
  {
    path: "/inspection_zones",
    name: "InspectionZone",
    component: InspectionZone
  },
  {
    path: "/locations",
    name: "Locations",
    component: Locations
  },
  {
    path: "/reportform",
    name: "ReportForm",
    component: ReportForm
  },
  {
    path: "/reports",
    name: "Report",
    component: Report
  },

  {
    path: "/survey/:page",
    name: "SurveyPage",
    component: Report,
    props: true
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
